"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeAgo = timeAgo;
exports.delay = delay;
function timeAgo(date) {
    const now = new Date();
    const diff = now.getTime() - date.getTime();
    // Define the time intervals in milliseconds
    const minute = 60 * 1000;
    const hour = 60 * minute;
    const day = 24 * hour;
    const week = 7 * day;
    const month = 30 * day;
    const year = 365 * day;
    if (diff < minute) {
        const seconds = Math.floor(diff / 1000);
        return `${seconds} ${seconds === 1 ? "second" : "seconds"} ago`;
    }
    else if (diff < hour) {
        const minutes = Math.floor(diff / minute);
        return `${minutes} ${minutes === 1 ? "minute" : "minutes"} ago`;
    }
    else if (diff < day) {
        const hours = Math.floor(diff / hour);
        return `${hours} ${hours === 1 ? "hour" : "hours"} ago`;
    }
    else if (diff < week) {
        const days = Math.floor(diff / day);
        return `${days} ${days === 1 ? "day" : "days"} ago`;
    }
    else if (diff < month) {
        const weeks = Math.floor(diff / week);
        return `${weeks} ${weeks === 1 ? "week" : "weeks"} ago`;
    }
    else if (diff < year) {
        const months = Math.floor(diff / month);
        return `${months} ${months === 1 ? "month" : "months"} ago`;
    }
    else {
        const years = Math.floor(diff / year);
        return `${years} ${years === 1 ? "year" : "years"} ago`;
    }
}
function delay(milliseconds) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve) => {
            setTimeout(resolve, milliseconds);
        });
    });
}
